<!--
/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */
 -->

<template>
    <leave-list-table :leave-statuses="leaveStatuses" :my-leave-list="true">
        <template #default="{filters, filterItems, rules, onReset}">
            <oxd-table-filter :filter-title="$t('leave.my_leave_list')">
                <oxd-form @submit-valid="filterItems" @reset="onReset">
                    <oxd-form-row>
                        <oxd-grid :cols="4" class="orangehrm-full-width-grid">
                            <oxd-grid-item>
                                <date-input
                                    v-model="filters.fromDate"
                                    :label="$t('general.from_date')"
                                    :rules="rules.fromDate"
                                />
                            </oxd-grid-item>
                            <oxd-grid-item>
                                <date-input
                                    v-model="filters.toDate"
                                    :label="$t('general.to_date')"
                                    :rules="rules.toDate"
                                />
                            </oxd-grid-item>
                            <oxd-grid-item>
                                <oxd-input-field
                                    v-model="filters.statuses"
                                    value="Select"
                                    type="multiselect"
                                    :label="$t('leave.show_leave_with_status')"
                                    :options="leaveStatuses"
                                    :rules="rules.statuses"
                                    required
                                />
                            </oxd-grid-item>
                            <oxd-grid-item>
                                <leave-type-dropdown
                                    v-model="filters.leaveType"
                                    :eligible-only="true"
                                    :include-allocated="true"
                                />
                            </oxd-grid-item>
                        </oxd-grid>
                    </oxd-form-row>

                    <oxd-divider />

                    <oxd-form-actions>
                        <required-text />
                        <oxd-button
                            display-type="ghost"
                            :label="$t('general.reset')"
                            type="reset"
                        />
                        <oxd-button
                            class="orangehrm-left-space"
                            display-type="secondary"
                            :label="$t('general.search')"
                            type="submit"
                        />
                    </oxd-form-actions>
                </oxd-form>
            </oxd-table-filter>
            <spam style="padding: 10px"></spam>
            <oxd-table-filter :filter-title="$t('View Calender')">
                <oxd-button
                    :class="{active: !isOrganization}"
                    class="btj-r"
                    display-type="secondary"
                    :label="$t('Leave List')"
                    @click="organ(false)"
                />
                <oxd-button
                    :class="{active: isOrganization}"
                    class="btj-l"
                    display-type="secondary"
                    :label="$t('Organization Wide')"
                    @click="organ(true)"
                />

                <span
                    style="
                        float: right;
                        margin-bottom: 15px;
                        font-family: Nunito Sans, sans-serif;
                        font-size: 12px;
                        margin-top: 7px;
                    "
                    class="hidemb"
                >
                    <span
                        style="
                            width: 15px;
                            height: 15px;
                            background-color: #2c9537;
                            float: left;
                        "
                    ></span>
                    <span style="width: 70px; height: 15px; float: left"
                        >&nbsp;&nbsp;Approved&nbsp;&nbsp;</span
                    >
                    <span
                        style="
                            width: 15px;
                            height: 15px;
                            background-color: #848484;
                            float: left;
                        "
                        >&nbsp;&nbsp;</span
                    >
                    <span style="width: 50px; height: 15px; float: left"
                        >&nbsp;&nbsp;Pending</span
                    >
                </span>
                <!-- <button
                    class="oxd-button oxd-button--medium oxd-button--secondary"
                    @click="organ(false)"
                >
                    Leave List
                </button> -->
                <!-- <button @click="organ(true)">Organization Wide</button> -->
                <div class="oxd-table-filter-area calendar-container">
                    <FullCalendar
                        v-if="isMounted"
                        ref="calendar"
                        :options="calendarOptions"
                    ></FullCalendar>
                </div>
            </oxd-table-filter>
        </template>
    </leave-list-table>
</template>

<script>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function formatDate(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function getLastDayOfMonth() {
    const today = new Date();
    // Set the date to the 1st day of the next month
    const nextMonthFirstDay = new Date(
        today.getFullYear(),
        today.getMonth() + 1,
        1,
    );
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    // Subtract one day to get the last day of the current month
    const lastDayOfMonth = new Date(nextMonthFirstDay.getTime() - 86400000); // 86400000 ms = 1 day
    return {
        fromDate: formatDate(firstDayOfMonth),
        toDate: formatDate(lastDayOfMonth),
    };
}

// const fetchEvents = async (info, successCallback, failureCallback) => {
//     var start = new Date(info.startStr);
//     // eslint-disable-next-line no-redeclare
//     var start = start.toISOString().split('T')[0];
//     var end = new Date(info.endStr);
//     // eslint-disable-next-line no-redeclare
//     var end = end.toISOString().split('T')[0];
//     try {
//         const response = await axios.get(
//             '/web/index.php/api/v2/leave/calendar',
//             {
//                 params: {
//                     fromDate: start,
//                     toDate: end,
//                 },
//             },
//         );

//         // events.value = response.data; // Assuming your API returns an array of events data
//         successCallback(response.data.data);
//     } catch (error) {
//         console.error('Error fetching events:', error);
//         failureCallback(error);
//     }
// };

import LeaveListTable from '@/orangehrmLeavePlugin/components/LeaveListTable';
import LeaveTypeDropdown from '@/orangehrmLeavePlugin/components/LeaveTypeDropdown';

import FullCalendar from '@fullcalendar/vue3';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';

import axios from 'axios';

export default {
    components: {
        'leave-list-table': LeaveListTable,
        'leave-type-dropdown': LeaveTypeDropdown,
        FullCalendar,
    },
    props: {
        leaveStatuses: {
            type: Array,
            default: () => [],
        },
    },
    data: function () {
        return {
            calendarOptions: {
                plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                initialView: 'dayGridMonth',
                headerToolbar: {
                    left: 'prev,next',
                    center: 'title',
                    right: 'dayGridMonth,timeGridWeek,timeGridDay',
                },
                aspectRatio: 2,
                events: this.fetchEvents,
                eventContent: this.eventRender,
                contentHeight: 'auto',
                handleWindowResize: true,
            },
            isMounted: false,
            isOrganization: false,
        };
    },
    beforeMount() {
        setTimeout(() => {
            this.isMounted = true;
        }, 100);
    },
    mounted() {
        const elements = document.querySelectorAll(
            '.oxd-table-filter-header-options',
        );
        var i = 0;
        for (const element of elements) {
            if (i === 1) {
                element.addEventListener('click', () => {
                    this.$refs.calendar.getApi().refetchEvents();
                });
            }
            i++;
        }
    },
    //oxd-icon-button
    // created() {
    //     const apiUrl = '/web/index.php/api/v2/leave/calendar';
    //     const params = getLastDayOfMonth();
    //     // fromDate=2023-01-01&toDate=2023-12-31

    //     // axios.get(apiUrl, { params })
    //     axios
    //         .get(apiUrl, {params})
    //         .then((response) => {
    //             // this.calendarOptions.value.events = response.data.data;
    //             this.isMounted = true;
    //             // this.events = response.data.data;
    //             // console.log(response.data.data);
    //             // eslint-disable-next-line no-undef
    //         })
    //         .catch((error) => {
    //             // Handle errors
    //             console.error('Error fetching data:', error);
    //         });

    //     // fetch('/api/v2/leave/holidays')
    //     //     .then((response) => response.json())
    //     //     .then((data) => (this.totalVuePackages = data.total));
    // },
    methods: {
        eventRender(arg) {
            const eventTitle = arg.event.title;
            // const element = document.createElement('div');
            // element.style.display = 'block';
            // element.style.width = '100%';
            // element.innerHTML = eventTitle;
            return {html: eventTitle};
        },
        organ(arg) {
            this.isOrganization = arg;
            this.$refs.calendar.getApi().refetchEvents();
        },
        async fetchEvents(info, successCallback, failureCallback) {
            var start = new Date(info.startStr);
            // eslint-disable-next-line no-redeclare
            var start = start.toISOString().split('T')[0];
            var end = new Date(info.endStr);
            // eslint-disable-next-line no-redeclare
            var end = end.toISOString().split('T')[0];

            var params = {
                fromDate: start,
                toDate: end,
            };

            if (this.isOrganization) {
                params.type = 'org';
            }
            try {
                const response = await axios.get(
                    '/web/index.php/api/v2/leave/calendar',
                    {
                        params: params,
                    },
                );
                // eslint-disable-next-line no-prototype-builtins
                // if (response.value.hasOwnProperty('data')) {
                this.isMounted = true;
                successCallback(response.data.data);
                // }
            } catch (error) {
                console.error('Error fetching events:', error);
                failureCallback(error);
            }
        },
    },
};
</script>

<style>
.calendar-container {
    font-family: Nunito Sans, sans-serif;
    padding-top: 10px;
}
.fc-button {
    padding: 0 5px !important;
}
.fc .fc-toolbar-title {
    font-size: 18px;
    margin: 0px;
    color: #404040;
}
.fc-h-event {
    border: none !important;
    background-color: none !important;
}
span.fc-cal-data {
    padding: 0px 5px;
    display: block;
}
.btj-r {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
    border-top-left-radius: 3px !important;
    border-bottom-left-radius: 3px !important;
    padding: 8px 6px !important;
}
.btj-l {
    border-top-right-radius: 3px !important;
    border-bottom-right-radius: 3px !important;
    border-top-left-radius: 0 !important;
    border-bottom-left-radius: 0 !important;
    padding: 8px 14px !important;
}
.btj-r.active,
.btj-l.active {
    background-color: #528514 !important;
}
.oxd-table-filter-area {
    padding-top: 10px;
}
@media only screen and (max-width: 600px) {
    .hidemb {
        display: none;
    }
}
</style>
